import { type Meta } from '../types/docs';
import { WORKSPACE_AGENT_ANALYTICS_CATEGORY_META_PARAM } from './workspaceAgentAnalytics';

const META: Meta = {
  description: 'The user unarchives a workspace agent thread from My Tasks or the archived composer dock',
  name: 'agent_thread_unarchived',
  params: [WORKSPACE_AGENT_ANALYTICS_CATEGORY_META_PARAM],
};

export default META;
